import React, { useEffect, useState } from "react";
import { useParams, useNavigate, NavLink } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import house from "../../../../../images/house.png";
import pin from "../../../../../images/pin.png";
import "../../../../../css/empresa_uno/home.css";
import montania from "../../../../../images/montania.png";
/* componentes */
import { MontaniaEdit } from "../../../../empresa_uno_comp/home_menu/montaniaEdit";
import { CompanyUbication } from "../../../../empresa_uno_comp/home_menu/companyUbication";
import { Company_meprofile } from "../../../../../pages/company_meprofile";
import { useCompanyAssigned } from "../../../../CompanyAssignedContext";
import HomeIcon from "../../../../../svg/homeIcon";
import MontaniaIcon from "../../../../../svg/montaniaIcon";
import MapIcon from "../../../../../svg/mapIcon";
import LupaIcon from "../../../../../svg/lupaIcon";
import { useProveedorCompany, Error404 } from '../../../../../components';
import MenuIcon from '@mui/icons-material/Menu';
import GlobalGraphics from "../../../../empresa_uno_comp/home_menu/GlobalGraphics";
import { Preloader } from "../../../../Preloader";
import CompanyAccount from "../../../../empresa_uno_comp/home_menu/CompanyAccount";
import { GlobalPublications } from "../../../../../pages/GlobalPublications";

const array_subdirectorys = [
	"cuenta",//0
	"inicio",//1
	"nosotros",//2
	"publicaciones",//3
	"ventas",//4
	"numero-ventas",//5
	"beneficio",//6
	"clientes",//7
	"vendedores",//8
];


export const Home_EU = ({ sucursal_selected, obj_sucursal, setSelected }) => {
	const navigate = useNavigate();
	const { nit, sub_direc } = useParams();

	const { currentBranch, loadImageS, returnCurrency } = useProveedorCompany();

	const currenRoll = currentBranch?.code ?? "none";

	const pageAllow = {
		V2D0: {
			[array_subdirectorys[0]]: false,
			[array_subdirectorys[1]]: true,
			[array_subdirectorys[2]]: true,
			[array_subdirectorys[3]]: true,
			[array_subdirectorys[7]]: true,
		},
		S3C1: {
			[array_subdirectorys[0]]: false,
			[array_subdirectorys[1]]: true,
			[array_subdirectorys[2]]: true,
			[array_subdirectorys[3]]: true,
			[array_subdirectorys[7]]: true
		},
		A1M0: {
			[array_subdirectorys[0]]: false,
			[array_subdirectorys[1]]: true,
			[array_subdirectorys[2]]: true,
			[array_subdirectorys[3]]: true,
			[array_subdirectorys[4]]: true,
			[array_subdirectorys[5]]: true,
			[array_subdirectorys[7]]: true,
			[array_subdirectorys[8]]: true,
		},
		G3R1: {
			[array_subdirectorys[0]]: false,
			[array_subdirectorys[1]]: true,
			[array_subdirectorys[2]]: true,
			[array_subdirectorys[3]]: true,
			[array_subdirectorys[4]]: true,
			[array_subdirectorys[5]]: true,
			[array_subdirectorys[6]]: true,
			[array_subdirectorys[7]]: true,
			[array_subdirectorys[8]]: true,
		},
		S4A1: {
			[array_subdirectorys[0]]: true,
			[array_subdirectorys[1]]: true,
			[array_subdirectorys[2]]: true,
			[array_subdirectorys[3]]: true,
			[array_subdirectorys[4]]: true,
			[array_subdirectorys[5]]: true,
			[array_subdirectorys[6]]: true,
			[array_subdirectorys[7]]: true,
			[array_subdirectorys[8]]: true,
		},
	}

	const spanDefault = (texto = "") => {
		return (<span className="color-text-option">{texto}</span>);
	}

	const elementOptions = (colorIcon, position) => {
		const component = {
			[array_subdirectorys[0]]: spanDefault('Mi Cuenta'),
			[array_subdirectorys[1]]: (<Box><HomeIcon size={42} color={colorIcon} /></Box>),
			[array_subdirectorys[2]]: (<Box><MapIcon size={42} color={colorIcon} /></Box>),
			[array_subdirectorys[3]]: (<Box><MontaniaIcon size={42} color={colorIcon} /></Box>),
			[array_subdirectorys[4]]: spanDefault('Ventas'),
			[array_subdirectorys[5]]: spanDefault('Número de Ventas'),
			[array_subdirectorys[6]]: spanDefault('Beneficios'),
			[array_subdirectorys[7]]: spanDefault('Clientes'),
			[array_subdirectorys[8]]: spanDefault('Vendedores'),
		};

		return component[position];
	};

	const renderContent = () => {
		if ((!obj_sucursal || obj_sucursal.length === 0) && !sucursal_selected) return <div>No hay sucursales disponibles</div>;

		var allowedForced = null;
		if (currentBranch?.code == "none") return <div> No tienes los permisos suficientes para acceder aquí!</div>

		if (!pageAllow[currenRoll]?.[sub_direc]) {
			if (!pageAllow[currenRoll]) return (<Preloader />);

			const getAllowed = Object.keys(pageAllow[currenRoll]);

			allowedForced = getAllowed[getAllowed.length - 1];
			navigate(`/administrar/empresa/${allowedForced}/${nit}`, { replace: true });
		}

		switch (allowedForced ?? sub_direc) {
			case "cuenta":
				return (
					<CompanyAccount key_branch={currentBranch?.key_branch} />
				);
			case "inicio":
				return (
					<MontaniaEdit key_branch={currentBranch?.key_branch} loadImageS={loadImageS} convertPrice={returnCurrency} />
				);
			case "publicaciones":
				return (
					<div className='central-main-content' style={{ margin: 'auto' }}>
						<GlobalPublications where={'branch'} keyBranch={currentBranch?.key_branch} />
					</div>
				)
			case "ventas":
				return (
					<GlobalGraphics currentBranch={currentBranch} convertPrice={returnCurrency} dataFrom={'totals'} />
				);
			case "numero-ventas":
				return (
					<GlobalGraphics currentBranch={currentBranch} convertPrice={returnCurrency} dataFrom={'number'} valueType="number" />
				);
			case "beneficio":
				return (
					<GlobalGraphics currentBranch={currentBranch} convertPrice={returnCurrency} dataFrom={'earnings'} />
				);
			case "clientes":
				return (
					<GlobalGraphics currentBranch={currentBranch} convertPrice={returnCurrency} dataFrom={'client'} valueType="number" />
				);
			case "vendedores":
				return (
					<GlobalGraphics currentBranch={currentBranch} convertPrice={returnCurrency} dataFrom={'salesperson'} sellers={true} />
				);
			case "nosotros":
				return (
					<CompanyUbication
						currentBranch={currentBranch?.key_branch}
					/>
				);
			default:
				return <div>Selecciona una sección valida</div>;
		}
	};

	return (
		<div className="contenedor-home-company">
			<div className="menu-company">
				<div className="section-countain">
					{
						array_subdirectorys.map((valor, index) => (
							pageAllow[currenRoll]?.[array_subdirectorys[index]] && (
								<NavLink
									to={`/administrar/empresa/${valor}/${nit}`}
									className="item-countain"
									style={({ isActive }) => ({
										borderBottom: `3px solid ${isActive ? 'var(--theme-company)' : "transparent"}`,
									})}
									onMouseEnter={e =>
										(e.currentTarget.style.borderBottom = `3px solid var(--theme-company)`)}
									onMouseLeave={(e) => {
										const link = e.currentTarget;
										if (!link.classList.contains("active")) {
											link.style.borderBottom = "3px solid transparent";
										}
									}}
								>
									{elementOptions('var(--theme-company)', array_subdirectorys[index] ?? 'cuenta')}
								</NavLink>
							)
						))
					}
				</div>
			</div>

			<div className="floating-menu">
				<button className="default-buttons">
					<MenuIcon sx={{ color: 'var(--theme-company)', fontSize: '50px' }} />
				</button>
				<ul>
					<div style={{ position: 'absolute', top: '0px', left: '0px', height: '100%', width: '100%', backgroundColor: 'var(--theme-company)', zIndex: 0, opacity: .15, filter: 'blur(15px)' }}></div>
					{
						array_subdirectorys.map((valor, index) => (
							pageAllow[currenRoll]?.[array_subdirectorys[index]] && (
								<li style={{ backgroundColor: array_subdirectorys[index] == sub_direc ? 'rgba(0,0,0,0.15)' : 'transparent', zIndex: 2 }}>
									<NavLink
										to={`/administrar/empresa/${valor}/${nit}`}
									>
										{elementOptions('var(--theme-main)', array_subdirectorys[index] ?? 'cuenta')}
									</NavLink>
								</li>
							)
						))
					}
				</ul>
			</div>

			<div className="content-display">{sub_direc && renderContent()}</div>
		</div>
	);
};

export default Home_EU;
